<template>
    <div class="app" v-if="maDate !== undefined">
        <div class="fond-haut-page">
            <div class="img-fond-haut-page" :style="'background-image: url('+monImageFond+');'" alt="">

            </div>
            <div class="filtre-haut-page"></div>
        </div>

        <section class="page page-histoire page-section-full">
            <section class="section-page">
                <section class="colonne-gauche">
                    <div class="cadre-image-centre-y" v-if="maDate.images !== null">
                        <div class="grande-image-liste-images-carroussel bg-blanc" alt="image">
                            <img :src="monImageAggrandie" class="img-liste-carroussel" alt="">
                        </div>
                        <div class="div-liste-images-carroussel">
                            <div v-for="image in maDate.images" :key="image.id" @click="monImageAggrandie = image.full_image_url" class="petite-image-liste-images-carroussel cursor bg-blanc">
                                <img :src="image.thumbnail_image_url" class="img-liste-carroussel" :alt="image.title">
                            </div>
                        </div>
                    </div>
                    <div class="cadre-image-centre-y" v-else>
                        <div class="text-center">
                            <div class="grande-image-liste-images-carroussel bg-blanc" style="display: flex; align-items: center;" alt="image">
                                <i class="text-light">Aucune image est disponible pour le moment</i>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="colonne-centrale colonne-centre-avec-gauche">
                    <div class="cadre-description-centre-y">
                        <h3 class="c-gris-blanc">{{maDate.titre}}</h3>
                        <i class="c-gris-blanc">{{maDate.date}}</i>
                        <p class="c-gris-blanc" v-html="maDate.description"></p>
                    </div>
                </section>

                <section class="colonne-droite colonne-frise">
                    <div class="frise-vertical pr-section cursor-slide-verti" v-on:scroll="overflowFrise('frise-vertical', 'div-date-frise')">
                        <div class="div-date-frise">

                        </div>
                        <div class="div-date-frise" v-for="(date, index) in histoire">
                            <div class="cercle-date-frise cursor">

                            </div>
                            <div class="info-date-frise cursor" @click="choixDate = date.id, choixGdeImg(), scrollFrise('frise-vertical', 'div-date-frise', index)">    
                                <h3 class="date-frise c-gris-blanc" :class="{'opacity-50': date.id !== choixDate}">{{ date.date_frise }}</h3>
                                <p class="titre-date-frise c-gris-blanc" :class="{'opacity-50': date.id !== choixDate}">{{ date.titre }}</p>
                            </div>

                            <div class="barre-liaison-date-frise">
                            </div>
                        </div>
                    </div>
                </section>
            </section>
        </section>
    </div>
</template>

<script>
    import params           from '@/param/param.js'
    import fctFiltres       from '@/functions/filter.js'
    import fctTris          from '@/functions/tris.js'
    import fctDate          from '@/functions/date.js'
    import fctFunctions     from '@/functions/functions.js'
    import fctFunctionsSpe  from '@/functions/functions_specifiques.js'

    export default {
        name: 'Accueil',
            data () {
                return {
                    params,
                    fctFiltres,
                    fctTris,
                    fctDate,
                    fctFunctions,
                    fctFunctionsSpe,

                    histoire: [],
                    choixDate: '',
                    monImageAggrandie: '',
                    monImageFond: ''
                }
            },
            
            created(){
                axios.get(params.host+'domaine/v1/listeDomaines')
                .then(response => {
                    this.monDomaine = fctFiltres.filterBy(response.data, params.domaineID, 'id')[0]
                
                    axios.get(params.host+'histoire/v1/listeDates')
                    .then(response => {
                        this.histoire = fctTris.orderNumberType(fctFiltres.filterByListe(response.data, 'domaine', 'frise'), this.monDomaine.reglages.histoire_order, 'order')
                        this.choixDate = this.histoire[0].id
                        this.choixGdeImg()
                    }).catch(error => {
                        console.log(error)
                    })
                }).catch(error => {
                    console.log(error)
                })
            },

            computed: {
                maDate(){
                    return fctFiltres.filterBy(this.histoire, this.choixDate, 'id')[0]
                },
            }, 

            methods:{
                choixGdeImg(){
                    if(this.maDate.image_fond === null){
                        this.monImageFond = this.monDomaine.image_accueil
                    }else{
                        this.monImageFond = this.maDate.image_fond
                    }

                    if(this.maDate.images === null){
                        this.monImageAggrandie = undefined
                    }else{
                        this.monImageAggrandie = this.maDate.images[0].full_image_url
                    }
                },

                overflowFrise(id, idEl){
                    let frise = document.querySelectorAll('.'+id)
                    let datesFrise = document.querySelectorAll('.'+idEl)
                    let heightDateFrise = datesFrise[1].clientHeight
                    let index = Math.round(frise[0].scrollTop / heightDateFrise)

                    this.choixDate = this.histoire[index].id
                    this.choixGdeImg()
                },

                scrollFrise(id, idEl, i){
                    let frise = document.querySelectorAll('.'+id)
                    let datesFrise = document.querySelectorAll('.'+idEl)
                    let positionTo = datesFrise[0].clientHeight * i

                    frise[0].scrollTo({
                        top: positionTo,
                        left: 0,
                        behavior: 'smooth'
                    })
                }
            },

            filters: {

            }
        }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Histoire.vue